// @flow

import config from 'config/app.config';
import { BasePath } from 'config/paths';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import {
  GET_DATALAYER_REQUEST,
  CLEAR_TAG_MANAGER_RESPONSES,
  UPDATE_DATALAYER,
} from '../store/actions';
import type { RootState, DataLayer } from '../store/types';
import TagManager from '../utils/TagManagerUtils';

const useTagManager = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const common = useSelector((state: RootState) => state.common);
  const tagManager = useSelector((state: RootState) => state.tagManager);

  const generateDataLayer = (dataLayer: DataLayer): DataLayer => {
    const newDataLayer: DataLayer = {
      ...dataLayer,
      page: `${window.location.pathname}${window.location.search}`,
      step: `${common.step !== 0 ? common.step : ''}`,
      landing:
        window.location.pathname.search('/landing') !== -1
        || (config.hosted && config.landingName && !window.location.pathname.startsWith(BasePath))
          ? '1'
          : '0',
    };

    switch (newDataLayer.at) {
      case 'PM':
        newDataLayer.type = 'PM_REGISTRATION';
        break;
      case 'RMT':
      case 'RMF':
        newDataLayer.type = 'RM_REGISTRATION';
        break;
      default:
        break;
    }

    dispatch({
      type: UPDATE_DATALAYER,
      payload: newDataLayer,
    });

    return newDataLayer;
  };

  useEffect(() => {
    dispatch({
      type: GET_DATALAYER_REQUEST,
      payload: {
        jwt: common.jwt,
        tracker: config.tracker,
      },
    });
  }, [history.location]);

  useEffect(() => {
    if (tagManager.getDataLayer.success) {
      TagManager.sendDataLayer(
        generateDataLayer({
          ...tagManager.dataLayer,
          ...tagManager.getDataLayer.response?.dataLayer,
        }),
      );

      dispatch({ type: CLEAR_TAG_MANAGER_RESPONSES });
    }
  }, [tagManager.getDataLayer.success]);
};

export default useTagManager;
